// Near-duplicate location pages kept live but hidden from search ("noindex, follow").
// Chosen by the Oct 2026 location audit (>=75% text overlap, no real local projects).
export const NOINDEX_LOCATION_PATHS = new Set<string>([
  // Outdated trend article, hidden by the Oct 2026 content audit (kept live).
  "/blog/interior-paint-color-trends-2025/",
  "/cabinet-refinishing-cliffside-park-nj/",
  "/cabinet-refinishing-englewood-nj/",
  "/cabinet-refinishing-fair-lawn-nj/",
  "/cabinet-refinishing-glen-rock-nj/",
  "/cabinet-refinishing-hackensack-nj/",
  "/cabinet-refinishing-hoboken-nj/",
  "/cabinet-refinishing-little-falls-nj/",
  "/cabinet-refinishing-mahwah-nj/",
  "/cabinet-refinishing-morristown-nj/",
  "/cabinet-refinishing-paramus-nj/",
  "/cabinet-refinishing-parsippany-nj/",
  "/cabinet-refinishing-ridgewood-nj/",
  "/cabinet-refinishing-teaneck-nj/",
  "/cabinet-refinishing-totowa-nj/",
  "/cabinet-refinishing-wayne-nj/",
  "/cabinet-refinishing-weehawken-nj/",
  "/cabinet-refinishing-woodland-park-nj/",
  "/cliffside-park-nj/",
  "/commercial-interior-painting-englewood-nj/",
  "/commercial-interior-painting-mahwah-nj/",
  "/deck-staining-cliffside-park-nj/",
  "/deck-staining-englewood-nj/",
  "/deck-staining-fair-lawn-nj/",
  "/deck-staining-glen-ridge-nj/",
  "/deck-staining-glen-rock-nj/",
  "/deck-staining-hackensack-nj/",
  "/deck-staining-hoboken-nj/",
  "/deck-staining-little-falls-nj/",
  "/deck-staining-mahwah-nj/",
  "/deck-staining-montclair-nj/",
  "/deck-staining-morristown-nj/",
  "/deck-staining-paramus-nj/",
  "/deck-staining-parsippany-nj/",
  "/deck-staining-ridgewood-nj/",
  "/deck-staining-teaneck-nj/",
  "/deck-staining-totowa-nj/",
  "/deck-staining-wayne-nj/",
  "/deck-staining-weehawken-nj/",
  "/deck-staining-woodland-park-nj/",
  "/englewood-nj/",
  "/exterior-painting-cliffside-park-nj/",
  "/exterior-painting-englewood-nj/",
  "/exterior-painting-glen-rock-nj/",
  "/exterior-painting-hoboken-nj/",
  "/exterior-painting-morristown-nj/",
  "/exterior-painting-parsippany-nj/",
  "/exterior-painting-weehawken-nj/",
  "/exterior-painting-woodland-park-nj/",
  "/franklin-lakes-nj/",
  "/glen-rock-nj/",
  "/hoboken-nj/",
  "/interior-painting-cliffside-park-nj/",
  "/interior-painting-englewood-nj/",
  "/interior-painting-fair-lawn-nj/",
  "/interior-painting-glen-rock-nj/",
  "/interior-painting-hackensack-nj/",
  "/interior-painting-hoboken-nj/",
  "/interior-painting-little-falls-nj/",
  "/interior-painting-mahwah-nj/",
  "/interior-painting-montclair-nj/",
  "/interior-painting-morristown-nj/",
  "/interior-painting-paramus-nj/",
  "/interior-painting-parsippany-nj/",
  "/interior-painting-ridgewood-nj/",
  "/interior-painting-teaneck-nj/",
  "/interior-painting-totowa-nj/",
  "/interior-painting-wayne-nj/",
  "/interior-painting-weehawken-nj/",
  "/interior-painting-woodland-park-nj/",
  "/morristown-nj/",
  "/parking-lot-striping-bloomfield-nj/",
  "/parking-lot-striping-clifton-nj/",
  "/parking-lot-striping-englewood-nj/",
  "/parking-lot-striping-fair-lawn-nj/",
  "/parking-lot-striping-franklin-lakes-nj/",
  "/parking-lot-striping-hackensack-nj/",
  "/parking-lot-striping-little-falls-nj/",
  "/parking-lot-striping-mahwah-nj/",
  "/parking-lot-striping-montclair-nj/",
  "/parking-lot-striping-nutley-nj/",
  "/parking-lot-striping-paramus-nj/",
  "/parking-lot-striping-ridgewood-nj/",
  "/parking-lot-striping-teaneck-nj/",
  "/parking-lot-striping-totowa-nj/",
  "/parking-lot-striping-wayne-nj/",
  "/parsippany-nj/",
  "/ramsey-nj/",
  "/wallpaper-cliffside-park-nj/",
  "/wallpaper-englewood-nj/",
  "/wallpaper-fair-lawn-nj/",
  "/wallpaper-glen-rock-nj/",
  "/wallpaper-hackensack-nj/",
  "/wallpaper-hoboken-nj/",
  "/wallpaper-little-falls-nj/",
  "/wallpaper-mahwah-nj/",
  "/wallpaper-montclair-nj/",
  "/wallpaper-morristown-nj/",
  "/wallpaper-paramus-nj/",
  "/wallpaper-parsippany-nj/",
  "/wallpaper-ramsey-nj/",
  "/wallpaper-ridgewood-nj/",
  "/wallpaper-teaneck-nj/",
  "/wallpaper-totowa-nj/",
  "/wallpaper-verona-nj/",
  "/wallpaper-wayne-nj/",
  "/wallpaper-woodland-park-nj/",
  "/weehawken-nj/",
  "/woodland-park-nj/",
]);

export const isNoindexLocation = (path: string) => NOINDEX_LOCATION_PATHS.has(path.endsWith("/") ? path : path + "/");
